import {Layout, Typography, Anchor} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import BSI from './BSI';
import PDI from './PDI';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const {Text} = Typography;
const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const ResultsLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#PDI') {
      setBackI(appColors['ColorD']);
      setBackII('transparent');
    } else if (key === '#BSI') {
      setBackI('transparent');
      setBackII(appColors['ColorD']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#PDI' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorD'], fontSize: '3vh'}}>EMSA</Text></Content>}/>
          <Link href='#BSI' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorD'], fontSize: '1.4vh'}}>Biotin-streptavidin Interaction</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorD'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> R&nbsp;<br/> E&nbsp;<br/> S&nbsp;<br/> U&nbsp;<br/> L&nbsp;<br/> T&nbsp;<br/> S&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='PDI'>
              <PDI/>
            </div>
            <div id='BSI'>
              <BSI/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ResultsLogic;
